module.exports = __webpack_public_path__ + "static/img/aboutbanner.bbc4cfc.png";


//////////////////
// WEBPACK FOOTER
// ./public/aboutusImg/aboutbanner.png
// module id = 6PCZ
// module chunks = 0